import type { ProductConfigurableGtm } from '~/types/ProductConfigurableGtm'
import type { ProductBase } from '~/types/productBase'

export function getGtmFlagIdentifier(product: ProductBase | ProductConfigurableGtm) {
    return product.productBadges?.map((item) => item.identifier) || []
}
